export default "__VITE_ASSET__CQRjzPJD__"